import { Button, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { AddContactTitle } from "../../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import { setNewModal } from "../../../../../ReduxToolkit/Reducers/Messenger/Messenger";

const ContactModal = () => {
  const dispatch = useAppDispatch();
  const { newModal } = useAppSelector((state) => state.messenger);
  return (
    <Modal isOpen={newModal[2]} toggle={() => dispatch(setNewModal(2))} className="fade show add-popup add-contact-modal" centered>
      <ModalHeader>{AddContactTitle}
        <Button className="close" onClick={() => dispatch(setNewModal(2))}>
          <span>×</span>
        </Button>
      </ModalHeader>
      <ModalBody className="pt-2">
        <Form className="default-form">
          <div className="form-group text-center">
            <h5>Email or Username</h5>
            <Input type="text" placeholder="Josephin water" />
          </div>
          <div className="form-group mb-0 text-center">
            <h5>Contact number</h5>
            <Input type="number" placeholder="12345678912" />
          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" size="sm" className="button-effect" onClick={() => dispatch(setNewModal(2))}>Cancel</Button>
        <Button color="primary" size="sm" className="button-effect">Add contact</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ContactModal;
